<template>
  <div class="pagination">
    <div
      @click="changePage(1)"
      class="pagination__first pagination__element"
      v-if="currentPage > 2"
      :class="{ 'pointer-class': isDisabled }"
    >&lt;&lt; Prva</div>
    <div
      @click="changePage(currentPage - 1)"
      class="pagination__previous pagination__element"
      v-if="currentPage > 1"
      :class="{ 'pointer-class': isDisabled }"
    >&lt;&lt; Prethodna</div>

    <div
      v-if="currentPage > 4 && numberOfPages > 5"
      @click="changePage(1)"
      class="pagination__element"
    >1</div>
    <div v-if="currentPage > 4 && numberOfPages > 5" class="pagination__element">...</div>

    <div
      class="pagination__element"
      :class="{ 'pagination__element--active': currentPage === n }"
      v-for="n in pagesToShow"
      :key="n"
      @click="changePage(n)"
    >{{ n }}</div>

    <div v-if="currentPage < numberOfPages - 3 && numberOfPages > 5" class="pagination__element">...</div>
    <div
      v-if="currentPage < numberOfPages - 2 && numberOfPages > 5"
      @click="changePage(numberOfPages)"
      class="pagination__element"
    >{{ numberOfPages }}</div>

    <div
      v-if="currentPage < numberOfPages"
      @click="changePage(currentPage + 1)"
      class="pagination__next pagination__element"
    >Sledeća >></div>
    <div
      v-if="currentPage < numberOfPages - 1"
      @click="changePage(numberOfPages)"
      class="pagination__last pagination__element"
    >Poslednja >></div>
  </div>
</template>

<script>
export default {
  props: {
    totalCount: {
      required: true,
      type: Number
    },
    perPage: {
      required: false,
      default: 10,
      type: Number
    },
    currentPage: {
      required: false,
      type: Number
    }
  },

  computed: {
    isDisabled() {
      return this.currentPage === 1 ? true : false;
    },
    numberOfPages() {
      return Math.ceil(this.totalCount / this.perPage);
    },
    pagesToShow() {
      let pages = [];
      if (this.numberOfPages <= 5) {
        for (let i = 1; i <= this.numberOfPages; i++) {
          pages.push(i);
        }
      } else {
        let start = this.currentPage - 2 > 0 ? this.currentPage - 2 : 1;
        let end =
          this.currentPage + 2 <= this.numberOfPages
            ? this.currentPage + 2
            : this.numberOfPages;
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
      }
      return pages;
    }
  },
  methods: {
    changePage(pageNumber) {
      if (this.currentPage !== pageNumber) {
        this.$emit('pageChanged', pageNumber);
      }
    }
  }
};
</script>

<style>
.pagination {
  display: flex;
}
.pagination__element {
  cursor: pointer;
  min-width: 25px;
  min-height: 25px;
  border: solid 1px #dee2e6;
  border-radius: 3px;
  padding: 5px;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination__element--active {
  background-color: var(--primary-color);
  color: white;
}

.pagination__numbers {
  display: flex;
}

.pointer-class {
  pointer-events: none;
}
</style>
